<template>
  <el-container>
    <el-header>
      <div class="myheader">
        <img src="../../static/imgs/img_start_4.png" height="40px" width="120px"
             style="line-height: 40px;float: left;margin-left:20px;margin-top: 5px">
        <div class="sysName" style="flex: 1; text-align: left; margin-left: 10px;margin-top: 9px;font-weight: 600">乐读分发平台</div>
        <el-dropdown trigger="click" style="margin-right: 20px;">
          <span class="el-dropdown-link"><img id="avator"
                                              style="width: 40px;height: 40px;border-radius: 30px;margin-top: 5px;"></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="clearfix">个人资料</el-dropdown-item>
            <el-dropdown-item class="clearfix" @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-main>
      <el-tabs type="border-card" v-model="tableName" @tab-click="tableSelect">
        <el-tab-pane v-for="item in page_data" v-bind:key="item.app_id" :label="item.name" :name="item.app_id">
          <tabcontent v-if='tabs_data[item.app_id] && tabs_data[item.app_id]["select_data"]' :appid='item.app_id' :select_data="tabs_data[item.app_id]['select_data']" :list="tabs_data[item.app_id]['list']" :total_count="tabs_data[item.app_id]['total_count']" :page="tabs_data[item.app_id]['page']" :page_size="tabs_data[item.app_id]['page_size']" @search="search"></tabcontent>
        </el-tab-pane>
      </el-tabs>
      <!-- <div v-show="!is_show" class="desc" style="color: #909399; padding: 10px 0; font-size: 12px;">温馨提示：如有问题请@王雪奇@徐强</div> -->
    </el-main>
    <el-footer>
      <div class="desc" style="color: #909399; padding: 6px 0; font-size: 12px;">温馨提示：如有问题请@王雪奇@徐强</div>
    </el-footer>
  </el-container>
</template>
<style>
  .el-header {
    padding: 0px;
    margin: 0px;
    height: 50px!important;
    background-color: #409EFF;
  }
  .myheader {
    display: flex;
  }

  .el-footer {
    padding: 0px;
    margin: 0px;
    height: auto!important;
  }

  .el-footer .desc {
    border-top: 1px solid #f1f1f1;
  }

  .el-container.is-vertical {
    box-sizing: border-box;
  }

  .el-aside, .el-main {
    overflow-y: inherit;
    -webkit-box-sizing: border-box;
  }
  @media only screen and (max-width: 320px) {
    .sysName {
      font-size: 12px;
      line-height: 40px;
    }
  }
  @media only screen and (min-width: 321px) {
    .sysName {
      font-size: 20px;
    }
  }
</style>
<script>
  import tabcontent from '../components/tabcontent.vue'
  export default {
    components: {
      tabcontent: tabcontent
    },
    data () {
      return {
        loading: false,
        options_version_ios: [],
        options_env_ios: [],
        options_machine_ios: [],
        options_branch_ios: [],
        currentPageIos: 1,
        currentPageSizeIos: 10,
        currentPageAndroid: 1,
        currentPageSizeAndroid: 10,
        form_ios: {},
        form_android: {},
        ios_data: [],
        android_data: [],
        ios_appid: '',
        android_appid: '',
        tableName: null,
        // ...
        page_data: [],
        tabs_data: {},
        options_version: {},
        options_env: []
      }
    },
    mounted: function () {
      this.recover()
      this.gettickt()
    },
    methods: {
      recover () {
        // var formIosState = this.$store.state.formIos
        // var formAndroidState = this.$store.state.formAndroid
        // var table = this.$store.state.currentTab

        // if (this.isNotEmpty(formIosState)) {
        //   this.form_ios = formIosState
        //   console.log('form_ios = ' + formIosState)
        // }

        // if (this.isNotEmpty(formAndroidState)) {
        //   this.form_android = formAndroidState
        //   console.log('form_android = ' + formAndroidState)
        // }

        // if (this.isNotEmpty(table)) {
        //   this.tableName = table
        //   console.log('tableName = ' + table)
        // }
      },
      gettickt () {
        this.axios({
          method: 'get',
          url: 'v1/app/ticket',
          params: {
            appId: 'A376024058',
            appKey: '4LFh03FPbf6omXsX'
          }
        }).then((res) => {
          var ticket = res.data.data.ticket
          var token = this.GetQueryString('token')
          // 存一下本地 以用来避免复制详情页url重定向至列表页
          localStorage.setItem('A376024058_token', token)
          this.$store.commit('addToken', token)
          if (this.isNotEmpty(this.$store.state.token)) {
            this.getuserinfo(ticket, token)
          } else {
            window.location.href = 'https://sso.saash.vdyoo.com/portal/login/A376024058'
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      gettickt2 () {
        this.axios({
          method: 'get',
          url: 'v1/app/ticket',
          params: {
            appId: 'A376024058',
            appKey: '4LFh03FPbf6omXsX'
          }
        }).then((res) => {
          console.log('=========', res)
          var ticket = res.data.data.ticket
          // console.log('ticket每次都不一样', ticket)
          var token = this.GetQueryString('token')
          // 存一下本地 以用来避免复制详情页url重定向至列表页
          localStorage.setItem('A376024058_token', token)
          this.$store.commit('addToken', token)
          if (this.isNotEmpty(this.$store.state.token)) {
            this.getuserinfo(ticket, token)
          } else {
            window.location.href = 'https://sso.saash.vdyoo.com/portal/login/A376024058'
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      getuserinfo (ticket, token) {
        this.axios({
          method: 'get',
          url: 'v1/app/sso/verify',
          params: {
            token: token,
            ticket: ticket
          }
        }).then((res) => {
          if (res.data.data.errcode === 0 || res.data.data.errcode === '0') {
            document.getElementById('avator').src = res.data.data.avatar || './static/imgs/user.png'
            this.index()
          } else {
            this.$store.commit('addToken', '')
            window.location.href = 'https://sso.saash.vdyoo.com/portal/login/A376024058'
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      logout () {
        window.location.href = 'https://sso.saash.vdyoo.com/sso/logout?path=https://sso.saash.vdyoo.com/portal/login/A376024058'
      },
      GetQueryString (name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
        var r = window.location.search.substr(1).match(reg)
        var context = ''
        if (r != null) {
          context = r[2]
        }
        reg = null
        r = null
        return context == null || context === '' || context === 'undefined' ? '' : context
      },
      isNotEmpty (text) {
        if (text !== null && text !== '' && text !== 'null') {
          return true
        } else {
          return false
        }
      },
      isPC () {
        if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|OpenHarmony|openharmony)/i))) {
          return false
        } else {
          return true
        }
      },
      index () {
        this.axios({
          method: 'post',
          url: 'v1/app/list'
          // method: 'get',
          // url: './static/list.json'
        })
        .then((res) => {
          this.page_data = res.data.data
          if (!this.tableName || this.tableName === '0') {
            this.tableName = this.page_data[0]['app_id']
            // console.log(this.tableName)
          }
          this.getFilter(this.tableName)
          this.search({
            form: {},
            size: 10,
            page: 1,
            appid: this.tableName
          })
        }).catch((error) => {
          console.log(error)
        })
      },
      search (args) {
        // 单独处理时间为字符串
        args.form.uploadTime = args.form.uploadTime ? args.form.uploadTime + '' : ''
        // 处理page
        args.page = args.page ? args.page + '' : '1'
        this.$forceUpdate()
        this.axios({
          method: 'post',
          url: 'v1/app/search',
          // method: 'get',
          // url: './static/search.json',
          data: {
            version: args.form.version,
            buildNum: args.form.buildNum,
            env: args.form.env,
            sourceMac: args.form.sourceMac,
            branch: args.form.branch,
            uploadTime: args.form.uploadTime,
            md5: args.form.md5,
            appId: args.appid,
            page: args.page + '',
            pageSize: args.size + ''
          }
        })
        .then((res) => {
          var appid = args.appid
          var response = res.data.data || {}
          var dataList = response.data || []
          dataList.forEach((value, i) => {
            // console.log(this.isPC())
            if (!this.isPC()) {
              if (this.isNotEmpty(value.plist_url) && value.plist_url !== undefined && value.plist_url !== 'undefined') {
                // value.app_url = 'itms-services://?action=download-manifest&url=' + value.plist_url
                if (value.platform === 'ios'){
                  value.app_url = 'itms-services://?action=download-manifest&url=' + value.plist_url
                }else {
                // 把 value.plist_url 这个链接进行 urlencode 编码 然后拼接到https://leduapp-leduapi-prd-1313601664.cos.ap-nanjing.myqcloud.com/LeduAppClientResource/Harmony/html/index.html?manifest=
                  value.app_url = 'https://leduapp-leduapi-prd-1313601664.cos.ap-nanjing.myqcloud.com/LeduAppClientResource/Harmony/html/index.html?manifest=' + encodeURIComponent(value.plist_url)
                }
              } else {
                value.app_url = ''
              }
            }
            value.version = value.version + ' - ' + value.build_num
          })
          var data = this.tabs_data || {}
          data[appid] = data[appid] || {}
          data[appid]['list'] = dataList
          data[appid]['total_count'] = response.total_count
          data[appid]['page'] = response.page
          data[appid]['page_size'] = response.page_size
          this.tabs_data = data
          this.$forceUpdate()
        })
      },
      search2 (form, size, page, appid) {
        this.axios({
          method: 'post',
          url: 'v1/app/search',
          data: {
            version: form.version,
            buildNum: form.buildNum,
            env: form.env,
            sourceMac: form.sourceMac,
            branch: form.branch,
            uploadTime: form.uploadTime,
            appId: appid,
            page: page + '',
            pageSize: size + ''
          }
        }).then((res) => {
          this.loading = false
          var response = res.data.data
          if (appid === this.ios_appid) {
            if (!this.isNotEmpty(response.data)) {
              this.ios_data = null
              this.totalCountIos = 0
              this.$store.commit('iosTable', this.ios_data)
              this.$store.commit('iosCount', this.totalCountIos)
              return
            }
            response.data.forEach((value, i) => {
              console.log(this.isPC())
              if (!this.isPC()) {
                if (this.isNotEmpty(value.plist_url) && value.plist_url !== undefined && value.plist_url !== 'undefined') {
                  if (value.platform === 'ios'){
                    value.app_url = 'itms-services://?action=download-manifest&url=' + value.plist_url
                  }else{
                    // 把 value.plist_url 这个链接进行 urlencode 编码 然后拼接到https://leduapp-leduapi-prd-1313601664.cos.ap-nanjing.myqcloud.com/LeduAppClientResource/Harmony/html/index.html?manifest=
                    value.app_url = 'https://leduapp-leduapi-prd-1313601664.cos.ap-nanjing.myqcloud.com/LeduAppClientResource/Harmony/html/index.html?manifest=' + encodeURIComponent(value.plist_url)
                  }
                } else {
                  value.app_url = ''
                }
              }
              value.version = value.version + ' - ' + value.build_num
            })
            this.ios_data = response.data
            this.totalCountIos = response.total_count
            this.$store.commit('iosTable', this.ios_data)
            this.$store.commit('iosCount', this.totalCountIos)
          } else {
            if (!this.isNotEmpty(response.data)) {
              this.android_data = null
              this.totalCountAndroid = 0
              this.$store.commit('androidTable', this.android_data)
              this.$store.commit('androidCount', this.totalCountAndroid)
              return
            }
            response.data.forEach(function (value, i) {
              value.version = value.version + ' - ' + value.build_num
            })
            this.android_data = response.data
            this.totalCountAndroid = response.total_count

            this.$store.commit('androidTable', this.android_data)
            this.$store.commit('androidCount', this.totalCountAndroid)
          }
        }).catch((error) => {
          this.loading = false
          console.log(error)
        })
      },
      getFilter (appid) {
        this.axios({
          method: 'post',
          url: 'v1/app/filter',
          // method: 'get',
          // url: './static/filter.json',
          data: {
            appId: appid
          }
        }).then((res) => {
          var data = this.tabs_data || {}
          data[appid] = data[appid] || {}
          data[appid]['select_data'] = res.data.data
          this.tabs_data = data
          this.$forceUpdate()
        }).catch((error) => {
          console.log(error)
        })
      },
      getFilter2 (appid) {
        this.axios({
          method: 'post',
          url: 'v1/app/filter',
          data: {
            appId: appid
          }
        }).then((res) => {
          var response = res.data.data
          if (appid === this.ios_appid) {
            this.options_version_ios = response.version
            this.options_env_ios = response.env
            this.options_machine_ios = response.machine
            this.options_branch_ios = response.branch
          } else {
            this.options_version_android = response.version
            this.options_env_android = response.env
            this.options_machine_android = response.machine
            this.options_branch_android = response.branch
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      tableSelect (tab, event) {
        this.$store.commit('currentTabState', tab.name)
        this.getFilter(tab.name)
        // 如果当前tab下没有请求过数据 则拉取数据
        if (!this.tabs_data[tab.name]) {
          this.search({
            form: {},
            size: 10,
            page: 1,
            appid: tab.name
          })
        }
      },
      windowAlert () {
        this.$notify.error({
          title: '错误',
          message: '下载链接地址不存在'
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/home.vue